// fake file to allow `export * from 'algoliasearch-helper/types/algoliasearch'`
